export default __webpack_public_path__ + "static/media/banner3-mobile.bdfe40d9.png";